import Text, { ITextProps, TextVariant, TextWeight } from './Text'

export default Text
export type { ITextProps, TextVariant, TextWeight }